import '../properties/index.mjs';
import { dimensions } from '../properties/dimensions.mjs';
import { cameraResolution } from '../properties/cameraResolution.mjs';
import { imageSensor } from '../properties/imageSensor.mjs';
import { fieldOfView } from '../properties/fieldOfView.mjs';
import { nightVision } from '../properties/nightVision.mjs';
import { opticalZoom } from '../properties/opticalZoom.mjs';
import { smartDetections } from '../properties/smartDetections.mjs';
import { enhancedDetections } from '../properties/enhancedDetection.mjs';
import { licensePlateRecognition } from '../properties/licensePlateRecognition.mjs';
import { faceRecognition } from '../properties/faceRecognition.mjs';
import { aiRecognition } from '../properties/aiRecognition.mjs';
import { cameraAudio } from '../properties/cameraAudio.mjs';
import { outdoorReady } from '../properties/outdoorReady.mjs';
import { tamperResistance } from '../properties/tamperResistance.mjs';
import { deployment } from '../properties/deployment.mjs';
"use strict";
const physicalSecurityProperties = [dimensions, cameraResolution, imageSensor, fieldOfView, nightVision, opticalZoom, smartDetections, enhancedDetections, licensePlateRecognition, faceRecognition, aiRecognition, cameraAudio, outdoorReady, tamperResistance, deployment];
export { physicalSecurityProperties };
//# sourceMappingURL=physicalSecurity.mjs.map
